import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import { ChangePasswordError } from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: ChangePasswordError;
  changePassword(request: Boundaries["changePassword"]["request"]): void;
}

function useChangePassword(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isChangePasswordRequestPending),
    isRequestSuccess: useSelector(selector.isChangePasswordRequestSuccess),
    isRequestFailure: useSelector(selector.isChangePasswordRequestFailure),
    error: useSelector(selector.getChangePasswordError),
    changePassword: core.changePassword,
  };
}

export { useChangePassword };
